import React, { useState } from "react";
import {
  Button,
} from 'reactstrap';
import styled from "styled-components";
import { withSnackbarConsumer, Color } from "contexts/SnackbarContext/SnackbarContext.jsx";
import Dialog from "../Dialog/Dialog";
import Input from "../Input/Input";
import Field from "../Field/Field";

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 35px;
`;

const HumidityCalculatorDialog = ({
  isOpen,
  onClose,
  onCalculate,
  snackbarContext,
}) => {
  const [weight, setWeight] = useState({
    wet: "",
    dry: "",
  });

  const handleCalculate = () => {
    try {
      const { wet, dry } = weight;
      const result = (wet - dry) / dry;
      snackbarContext.setNotificationTimeOut(Color.success, "Teor de água calculado com sucesso.");
      onCalculate(result * 100);
      onClose();
    } catch (error) {
      console.error(error);
      snackbarContext.setNotificationTimeOut(Color.danger, "Erro ao calcular teor de água");
    }
  };

  const updateField = (key, value) => {
    setWeight(prev => ({ ...prev, [key]: value }));
  };

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Calcular teor de água"
      width="400px"
      footer={(
        <Button
          color="info"
          style={{ width: "100%" }}
          onClick={handleCalculate}
          disabled={weight.dry === "" || weight.wet === ""}
        >
          Calcular
        </Button>
      )}
    >
      <Row>
        <Field title="Peso Úmido" width="48%">
          <Input
            name="wet"
            style={{ minHeight: "40px" }}
            type="number"
            value={weight.wet}
            onChange={updateField}
          />
        </Field>
        <Field title="Peso Seco" width="48%">
          <Input
            name="dry"
            style={{ minHeight: "40px" }}
            type="number"
            value={weight.dry}
            onChange={updateField}
          />
        </Field>
      </Row>
    </Dialog>
  );
};

export default withSnackbarConsumer(HumidityCalculatorDialog);
